/* @flow */

import { assertObject } from '@e180/util/lib/assert';

import * as conversationTypes from 'src/shared/domain/conversation/action/conversationActionTypes';
import * as topicTypes from 'src/shared/domain/topic/action/topicActionTypes';
import * as entititesTypes from 'src/shared/domain/base/action/entityActionTypes';
import { createReducer } from 'src/shared/core/util/reducerUtils';

const initialState = {};

const _updateConversation = (state: Object, action: Object) => {
  const { result: conversationId, topicId } = action;

  const topic = state[topicId];

  return {
    ...state,
    [`${topicId}`]: {
      ...topic,
      conversation: conversationId,
    },
  };
};

const _removeConversationFromTopic = (state: Object, action: Object) => {
  const { topicId } = action;

  const topic = state[topicId];

  return {
    ...state,
    [`${topicId}`]: {
      ...topic,
      conversation: undefined,
      has_conversation: false,
    },
  };
};

const _bookmark = (state: Object, action: Object) => {
  const { id, bookmarked } = action;

  const topic = state[id];

  return {
    ...state,
    [`${id}`]: {
      ...topic,
      bookmarked,
    },
  };
};

const _bookable = (state: Object, action: Object) => {
  const { bookable, unbookableReason, id } = action;

  const topic = state[id];

  return {
    ...state,
    [`${id}`]: {
      ...topic,
      bookable,
      unbookableReason,
    },
  };
};

const patchModeration = (state: Object, { data }: Object) => {
  const { topic: topicId } = data;
  const topic = state[topicId] || {};

  return {
    ...state,
    [`${topicId}`]: {
      ...topic,
      moderation: data.state,
      moderationReason: data.reason,
    },
  };
};

const patchModerationReason = (state: Object, action: Object) => {
  const { moderationReason, id } = action;

  const topic = state[id] || {};

  return {
    ...state,
    [`${id}`]: {
      ...topic,
      moderationReason,
    },
  };
};

const _patch = (state: Object, { entities }: Object) => {
  assertObject(entities, 'entities');

  if ('topics' in entities) {
    const { topics } = entities;

    assertObject(topics, 'entities.topics');

    const patchedTopics = {};

    // Dirty
    for (const id in topics) {
      const patchedTopic = topics[id];
      const outdatedTopic = state[id];

      let mergedTopic;

      if (outdatedTopic) {
        mergedTopic = {
          ...outdatedTopic,
          ...patchedTopic,
        };

        const { conversation: conversationId } = outdatedTopic;

        if (conversationId) {
          mergedTopic.conversation = conversationId;
        }
      } else {
        mergedTopic = patchedTopic;
      }

      patchedTopics[id] = mergedTopic;
    }

    return {
      ...state,
      ...patchedTopics,
    };
  }

  return state;
};

export default createReducer(initialState, {
  [conversationTypes.FETCH_CONVERSATION_SUCCESS]: _updateConversation,
  [conversationTypes.REMOVE_CONVERSATION_FROM_TOPIC]: _removeConversationFromTopic,
  [topicTypes.BOOKMARK_TOPIC_SUCCESS]: _bookmark,
  [topicTypes.FETCH_IS_TOPIC_BOOKABLE_SUCCESS]: _bookable,
  [topicTypes.PATCH_TOPIC_MODERATION]: patchModeration,
  [topicTypes.FETCH_TOPIC_MODERATION_REASON_SUCCESS]: patchModerationReason,
  [entititesTypes.PATCH_ENTITIES]: _patch,
});
